/** True when the Maps JavaScript API is available on window. */
export function isGoogleMapsReady() {
  return Boolean(
    typeof window !== 'undefined' &&
      window.google &&
      window.google.maps &&
      window.google.maps.LatLng
  );
}

/**
 * Normalize permit/map coordinates for Google Maps (lat/lng must be finite numbers).
 */
export function parseCoord(value) {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : parseFloat(String(value).trim());
  return Number.isFinite(n) ? n : null;
}

/** @returns {{ lat: number, lng: number } | null} */
export function getPermitMapPosition(permit) {
  if (!permit) return null;
  const coords = permit.coordinates || permit.alarmLocation?.coordinates || {};
  const lat = parseCoord(coords.latitude ?? coords.lat);
  const lng = parseCoord(coords.longitude ?? coords.lng);
  if (lat == null || lng == null) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

/**
 * Validate lat/lng for permit forms.
 * @returns {{ ok: true, lat: number, lng: number } | { ok: false, message: string }}
 */
export function validateCoordinates(latitude, longitude) {
  const lat = parseCoord(latitude);
  const lng = parseCoord(longitude);
  if (lat == null) {
    return { ok: false, message: 'Latitude must be a number between -90 and 90.' };
  }
  if (lng == null) {
    return { ok: false, message: 'Longitude must be a number between -180 and 180.' };
  }
  if (lat < -90 || lat > 90) {
    return { ok: false, message: 'Latitude must be between -90 and 90.' };
  }
  if (lng < -180 || lng > 180) {
    return { ok: false, message: 'Longitude must be between -180 and 180.' };
  }
  return { ok: true, lat, lng };
}

/** Normalize { lat, lng } or { latitude, longitude } for Maps. */
export function normalizeMapPosition(position) {
  if (!position) return null;
  const lat = parseCoord(position.lat ?? position.latitude);
  const lng = parseCoord(position.lng ?? position.longitude);
  if (lat == null || lng == null) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

/** Permits that can be shown on a Google Map. */
export function permitsWithValidCoordinates(permits = []) {
  return permits
    .map((permit) => {
      const position = getPermitMapPosition(permit);
      return position ? { permit, position } : null;
    })
    .filter(Boolean);
}
